import { render, staticRenderFns } from "./serviceVersion__list.vue?vue&type=template&id=3a2d8212"
import script from "./serviceVersion__list.vue?vue&type=script&lang=js"
export * from "./serviceVersion__list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports